import * as ActionTypes from '../redux/ActionTypes';


export default (state=[], action) => {
	if (action.type === ActionTypes.SETTHEMES) {
		return [ ...state, ...action.themes ];
	} else {
		return state;
	}
}
